import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-conferma-dialog',
    templateUrl: './conferma-dialog.component.html'
})
export class ConfermaDialogComponent {

    constructor(@Inject(MAT_DIALOG_DATA) public data: ConfermaDialogOptions,
        public dialogRef: MatDialogRef<ConfermaDialogComponent>
    ) {
        // console.warn('data', data);
    }

}

export interface ConfermaDialogOptions {
    message: string;
    buttonLabel: string;
}
